export default __webpack_public_path__ + "assets/models/824140cb3455108cbac2e4917c66783a.glb";